module.exports = {
  RAILS_API_URL: 'https://aideal-api.appier.com',
  RAILS_API_PORT: 443,
  FACADE_API_URL: 'https://facade.zenclerk.com',
  FACADE_API_PORT: 443,
  ZC_APIKEY: 'emin-zc',
  ZC_TAG_EVENT_PREFIX: 'zc',
  AIDEAL_URL: 'https://aideal-app.appier.com',
  GRAPHQL_URL_APP: 'https://aideal-graphql.appier.com/graphql',
  GRAPHQL_URL_MASTER: 'https://aideal-graphql.appier.com/mgraphql',
  SENTRY_DSN: 'https://1ff4c3da9a49c5c5cded3a2d290bdde4@sentry.zenclerk.com/14',
  CONFIG_ENV: 'production',
  ENABLE_AUTH0: true,
};



// WEBPACK FOOTER //
// ./src/env.js